module.exports = __webpack_public_path__ + "static/media/answerPage3.9d6ee67e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerPage3.png
// module id = 1725
// module chunks = 0 1